import Tasks from 'APP/Tasks';
import { ISendFiles } from 'APP/Tasks/messaging/sendFiles/sendFiles.types';
import { MediaMessagePopup } from 'APP/main/PopupManager/Popups/MediaMessagePopup/MediaMessagePopup';
import { GroupType } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

export const sendFiles = ({ groupId, files }: ISendFiles): void => {
  const group = Entities.GroupsStore.getGroupById(groupId);
  const inputPanel = Entities.InputPanelsStore.getById(groupId);

  if (!group || !inputPanel) {
    return;
  }

  Tasks.app.openPopup(MediaMessagePopup, {
    params: {
      groupId,
      files: [...files],
      caption: group.type === GroupType.SecretGroup ? '' : inputPanel.markdownValue || '',
    },
  });

  inputPanel.setValue('');
  inputPanel.voice.reset();
};
